// Toggle dropdown
document.querySelectorAll('.c-sticky-atc .dropdown-select').forEach(el => {
  el.addEventListener('click', e => {
    e.stopPropagation(); // Prevent outside click from firing
    const parent = el.closest('.c-sticky-atc');

    // Close other open dropdowns
    parent.querySelectorAll('.dropdown-select.exp').forEach(openEl => {
      if (openEl !== el) openEl.classList.remove('exp');
    });

    // Toggle current dropdown
    el.classList.toggle('exp');
  });
});

// Close dropdown when clicking outside
document.addEventListener('click', e => {
  document.querySelectorAll('.c-sticky-atc .dropdown-select.exp').forEach(openEl => {
    if (!openEl.contains(e.target)) {
      openEl.classList.remove('exp');
    }
  });
});

// Handle label click inside dropdown
document.querySelectorAll('.c-sticky-atc .dropdown-options label').forEach(label => {
  label.addEventListener('click', e => {
    e.stopPropagation(); // Prevent reopening

    // Get the parent dropdown
    const dropdown = label.closest('.dropdown-select');
    if (!dropdown) return;

    // Get data-selling-plan-name from parent <li>
    const li = label.closest('li');
    const planName = li?.dataset.sellingPlanName || '(no data-selling-plan-name found)';
    

    // Trigger corresponding input click (vanilla JS)
    if (planName === 'one-time') {
      const oneTimeInput = document.querySelector('.product-subscriptions [data-frequency="One-time"]');
      if (oneTimeInput) oneTimeInput.closest('label').click();
    } else {
      const planInput = document.querySelector(`.product-subscriptions [data-selling-plan-name="${planName}"] label`);
      if (planInput) planInput.click();
    }

    // Get new title & price text
    const newTitle = label.querySelector('.product-subscriptions__subscription-label')?.textContent.trim() || '';
    const newPrice = label.querySelector('.product-subscriptions__subscription-price')?.innerHTML || '';

    // Replace displayed values
    const titleEl = dropdown.querySelector('.dropdown-selected__title');
    const priceEl = dropdown.querySelector('.dropdown-selected__price-per-serving');

    if (titleEl) titleEl.textContent = newTitle;
    if (priceEl) priceEl.innerHTML = newPrice;

    // Close the dropdown
    dropdown.classList.remove('exp');
  });
});



// Event delegation for dynamically added buttons
document.body.addEventListener('click', function(e) {
  const target = e.target.closest('.c-sticky-atc .button');
  if (!target) return;

  // Find all buy buttons and trigger click
  document.querySelectorAll('.product-info .buy-buttons .button').forEach(btn => {
    btn.click();
  });
});




// Show/hide sticky buy buttons on scroll with opacity transition
(function() {
  const stickyButtons = document.querySelector('[data-product-buy-buttons-sticky]');
  const storeHeader = document.querySelector('[data-store-header]');
  const announcementBar = document.querySelector('[data-announcement-bar]');
  
  if (!stickyButtons) return;

  const scrollThreshold = 100; // Show after scrolling 100px down
  let lastScrollY = window.scrollY;

  function handleScroll() {
    const currentScrollY = window.scrollY;

    if (currentScrollY > scrollThreshold) {
      // User has scrolled down - fade in sticky buttons, fade out header/announcement
      stickyButtons.classList.remove('is-hidden');
      stickyButtons.style.opacity = '1';
      
      if (storeHeader) {
        storeHeader.style.opacity = '0';
      }
      if (announcementBar) {
        announcementBar.style.opacity = '0';
      }
    } else {
      // User is near the top - fade out sticky buttons, fade in header/announcement
      stickyButtons.style.opacity = '0';
      // Add is-hidden class after transition completes
      setTimeout(() => {
        if (window.scrollY <= scrollThreshold) {
          stickyButtons.classList.add('is-hidden');
        }
      }, 300); // Match CSS transition duration
      
      if (storeHeader) {
        storeHeader.style.opacity = '1';
      }
      if (announcementBar) {
        announcementBar.style.opacity = '1';
      }
    }

    lastScrollY = currentScrollY;
  }

  // Initial check - start with opacity 0 for sticky buttons
  stickyButtons.style.opacity = '0';
  handleScroll();

  // Throttle scroll events for better performance
  let ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  });
})();


